<template>
  <div class="company">

    <template v-for="(section, sectionIndex) in AboutUnternehmen.content.sections">

      <div :key="'sectiontitle' + sectionIndex"
           class="primary--text subueber">{{ section.sectionTitle }}
      </div>

      <!-- all the BFV.. changes are included for just one additional picture and link in the
      bullet point: "Bundesarbeitsgemeinschaft zur Förderung der Versicherungsmakler"
      if subtitle exists it is used instead of title, content is interpreted as html
      for the Logo to appear it must be a .png file -->
      <ul :key="'sectionlist' + sectionIndex"
          class="company-block">
        <li v-for="(item, itemIndex) in section.items" 
            :key="sectionIndex + '_' + itemIndex">
            <!-- eslint-disable vue/no-v-html -->
            <span v-if="item.subtitle" v-html="item.subtitle"/>
            <!-- eslint-enable -->
            <span v-else>{{ item.title }}</span>
            <br v-if="item.link && item.link.includes('.png')">
            <img v-if="item.link && item.link.includes('.png')" :src="item.link" class="bfv-image" >
        </li>
      </ul>
    </template>

    <div class="mt-10">Der konkrete Versicherungsumfang ergibt sich aus den jeweiligen gültigen ARB.</div>

  </div>

</template>

<script>
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";

export default {
  name: "Unternehmen",
  components: {},
  mixins: [contentLoadingMixin(["AboutUnternehmen"])],
};

</script>
<style>

.company .subueber {
  margin: 40px 0 24px 0;
}

.company .subueber:first-child {
  margin-top: 0 !important;
}

.company .company-block {
  list-style: outside;
  margin-left: 16px;
  padding-left: 0;
}

.company .company-block li:not(:last-child) {
  margin-bottom: 16px;
}

.bfv-image {
  max-height: 120px;
}

</style>



